import { gql } from '@apollo/client'

export const GET_FILTERED_CAB_BOOKING_BY_OWNER_ID = gql`
  query GetFilteredCabBookingByFleetOwnerId(
    $filterCabInput: FilterCabInput!
    $pageNumber: Float
    $pageSize: Float
  ) {
    getFilteredCabBookingByFleetOwnerId(
      filterCabInput: $filterCabInput
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      cabBooking {
        id
        fares
        status
        operationCity
        carType
        tripType
        travelType
        createdBy
        created_at
        paymentMethod
        idShare
        estimatedDriverShare
        otp
        otherCancellationReason
        cancellationComment
        startingReading
        distance
        endingReading
        tentativeRelievingDate
        tentativeReportingDate
        history {
          reportingDate
          relievingDate
          description
          status
          updatedDate
          updatedBy
          updatedName
        }

        allocationHistory {
          status
          updatedDate
          updatedBy
          updatedName
        }
        customerId {
          id
          firstName
          lastName
          mobileNumber
          email
        }
        driverId {
          _id
          firstName
          lastName
          mobileNumber
        }
        cabId {
          _id
          carNo
          color
          variant
        }
        pickAddress {
          lat
          lng
          address
        }
        dropAddress {
          lat
          lng
          address
        }
        fleetOwnerId {
          _id
          mobileNumber
          firstName
          lastName
        }
        faresId {
          bookingId
          totalFares
          idFares
          fleetFares
          fleetShare
          idShare
        }
      }
      total
    }
  }
`
export const CREATE_CAB_BOOKING = gql`
  mutation CreateCabBooking($input: CreateCabBookingInput!) {
    createCabBooking(createCabBookingInput: $input) {
      status
    }
  }
`
export const GET_FLEET_OWNER_BY_MOBILE = gql`
  query GetFleetOwnersByMobileAndName(
    $mobileNumber: String!
    $name: String!
    $pageNumber: Float!
    $pageSize: Float!
  ) {
    getFleetOwnersByMobileAndName(
      mobileNumber: $mobileNumber
      name: $name
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      _id
      id
      firstName
      lastName
      mobileNumber
      emergencyNumber
      birthDate
      address
      city
      state
      operationCity
      driverId
      accountId
      email
      password
      isActive
      created_at
      createdBy
      updated_at
      updatedBy
    }
  }
`
export const GET_FLEET_DRIVERS_BY_OWNER_ID = gql`
  query GetDriverByFleetOwner($fleetOwnerId: String!) {
    getDriverByFleetOwner(fleetOwnerId: $fleetOwnerId) {
      _id
      firstName
      lastName
      mobileNumber
      email
      isActive
      permanentAddress
    }
  }
`

export const GET_CAB_BY_FLEET_OWNER = gql`
  query GetCabByFleetOwner($fleetOwnerId: String!) {
    getCabByFleetOwner(fleetOwnerId: $fleetOwnerId) {
      _id
      carNo
      variant
    }
  }
`
export const ALLOCATE_CAB_BOOKING = gql`
  mutation AllocateCabBooking($createCabBookingInput: CreateCabBookingInput!) {
    allocateCabBooking(createCabBookingInput: $createCabBookingInput) {
      id
      driverId {
        _id
      }
      cabId {
        _id
      }
      fleetOwnerId {
        _id
      }
      updated_at
      allocationHistory {
        status
      }
    }
  }
`
export const START_CAB_BOOKING = gql`
  mutation StartDutyBooking($createCabBookingInput: CreateCabBookingInput!) {
    startDutyBooking(createCabBookingInput: $createCabBookingInput) {
      status
    }
  }
`
export const OFF_CAB_BOOKING = gql`
  mutation OffDutyBooking($createCabBookingInput: CreateCabBookingInput!) {
    offDutyBooking(createCabBookingInput: $createCabBookingInput) {
      status
    }
  }
`
export const PAID_CAB_BOOKING = gql`
  mutation PaidDutyBooking($createCabBookingInput: CreateCabBookingInput!) {
    paidDutyBooking(createCabBookingInput: $createCabBookingInput) {
      status
    }
  }
`
export const CANCEL_CAB_BOOKING = gql`
  mutation CabBookingCancelled($createCabBookingInput: CreateCabBookingInput!) {
    cabBookingCancelled(createCabBookingInput: $createCabBookingInput) {
      status
    }
  }
`
export const UPDATE_CAB_BOOKING = gql`
  mutation UpdateCabBooking($createCabBookingInput: CreateCabBookingInput!) {
    updateCabBooking(createCabBookingInput: $createCabBookingInput) {
      status
    }
  }
`
export const FIND_ALL_UNIQUE_CAR_BRANDS = gql`
  query FindAllUniqueBrands {
    findAllUniqueBrands
  }
`
export const FIND_CARS_BY_BRAND = gql`
  query FindCarsByBrand($brand: String!) {
    findCarsByBrand(brand: $brand) {
      brand
      variant
      seatingCapacity
      carType
      createdAt
    }
  }
`
export const GET_BOOKING_BY_INCREMENTAL_ID = gql`
  query GetBookingByIncrementalId($id: String!) {
    getBookingByIncrementalId(id: $id) {
      id
      tentativeReportingDate
      tentativeRelievingDate
      fares
      status
      operationCity
      carType
      tripType
      travelType
      createdBy
      created_at
      idShare
      estimatedDriverShare
      otp
      otherCancellationReason
      cancellationComment
      startingReading
      distance
      endingReading
      history {
        reportingDate
        relievingDate
        description
        status
        updatedDate
        updatedBy
        updatedName
      }

      allocationHistory {
        status
        updatedDate
        updatedBy
        updatedName
      }
      customerId {
        id
        firstName
        lastName
        mobileNumber
        email
      }
      driverId {
        _id
        firstName
        lastName
        mobileNumber
      }
      cabId {
        _id
        carNo
        color
        variant
      }

      faresId {
        bookingId
        totalFares
        idFares
        fleetFares
        fleetShare
        idShare
      }

      pickAddress {
        lat
        lng
        address
      }
      dropAddress {
        lat
        lng
        address
      }
      fleetOwnerId {
        _id
        mobileNumber
        firstName
        lastName
      }
    }
  }
`

export const GET_FILTERED_CAB_BOOKING = gql`
  query GetFilteredCabBooking(
    $filterCabInput: FilterCabInput!
    $pageNumber: Float
    $pageSize: Float
  ) {
    getFilteredCabBooking(
      filterCabInput: $filterCabInput
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      cabBooking {
        id
        tentativeReportingDate
        tentativeRelievingDate
        fares
        status
        operationCity
        carType
        tripType
        travelType
        createdBy
        created_at
        idShare
        estimatedDriverShare
        otp
        otherCancellationReason
        cancellationComment
        startingReading
        distance
        endingReading
        history {
          reportingDate
          relievingDate
          description
          status
          updatedDate
          updatedBy
          updatedName
        }

        allocationHistory {
          status
          updatedDate
          updatedBy
          updatedName
        }
        customerId {
          id
          firstName
          lastName
          mobileNumber
          email
        }
        driverId {
          _id
          firstName
          lastName
          mobileNumber
        }
        cabId {
          _id
          carNo
          color
          variant
        }

        faresId {
          bookingId
          totalFares
          idFares
          fleetFares
          fleetShare
          idShare
        }

        pickAddress {
          lat
          lng
          address
        }
        dropAddress {
          lat
          lng
          address
        }
        fleetOwnerId {
          _id
          mobileNumber
          firstName
          lastName
        }
      }
      total
    }
  }
`

export const DEALLOCATE_CAB_BOOKING = gql`
  mutation DeallocateCabBooking(
    $bookingId: String!
    $updatedBy: String!
    $updatedName: String
  ) {
    deallocateCabBooking(
      bookingId: $bookingId
      updatedBy: $updatedBy
      updatedName: $updatedName
    ) {
      id
      status
    }
  }
`
